<template>
    <div>
       <div class="container-fluid" style="background-color: white">
           <nav class="navbar navbar-expand-lg navbar-light">
               <div class="ml-auto">
                   <form class="form-inline">
                       <input class="form-control mr-sm-2"
                              type="search"
                              v-model="search.name"
                              placeholder="รายการประเภทถุง"
                              aria-label="Search"/>
                       <button class="btn btn-success my-2 my-sm-0"
                               @click="searchBagType"
                               type="button">
                           <icon name="search"></icon>
                           ค้นหา
                       </button>&nbsp&nbsp
                       <button class="btn btn-warning"
                               @click="showImportBagTypeModal"
                                type="button">
                           <icon name="plus"></icon> เพิ่มประเภทถุง
                       </button>
                   </form>
                </div>
            </nav>
       </div>
        <div class="table-responsive">
            <table class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">รายการประเภทถุง</th>
                    <th scope="col">วันที่แก้ไข</th>
                    <th scope="col">แก้ไข / ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in bagType_List">
                    <td>{{data.name}}</td>
                    <td>{{data.created_at | moment("DD/MM/YYYY")}}</td>
                    <td>
                        <a @click="editBagType(data.id)">
                            <icon name="pencil-alt">
                            </icon>
                        </a>
                        &nbsp;&nbsp;
                        <a @click="showDeleteModal(data.id)">
                            <icon name="trash-alt">
                            </icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
            <div v-if="bagType_List.length > 0">
                <vue-pagination :pagination="dataPaginate"
                                @paginate="getBagTypePage">
                </vue-pagination>
            </div>
            <br>
            <b-modal
                    hide-footer
                    ref="import_data"
                    id="import"
                    title="เพิ่มประเภทถุง">
                <div class="row">
                    <div class="col-sm-4">ประเภทถุง</div>
                    <div class="col-sm-6">
                        <input class="form-control" v-model="form.name"/>
                    </div>
                </div>
                <br>
                <div class="col text-center">
                    <button type="button"
                            @click="saveBagType"
                            class="btn btn-success">
                        ตกลง
                    </button>
                    &nbsp&nbsp
                    <button type="button"
                            @click="hideImportBagTypeModal"
                            class="btn btn-outline-secondary">
                        ยกเลิก
                    </button>
                </div>
            </b-modal>
            <!--delete modal--->
            <b-modal hide-header hide-footer ref="delete_data">
                <div style="text-align: center;">
                    <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                    <br />
                    <button @click="deleteBagType"
                            type="button"
                            class="btn btn-success">
                        ตกลง
                    </button>
                    &nbsp&nbsp
                    <button @click="hideDeleteModal"
                            type="button"
                            class="btn btn-secondary">
                        ยกเลิก
                    </button>
                </div>
            </b-modal>
        </div>
        <!--<pre class="alert-primary">{{form}}</pre>-->
    </div>

</template>

<script>
    import { mapState } from "vuex";
    import moment from "moment";
    import VuePagination from "../../Pagination";

    export default {
        components: {
            VuePagination,
        },
        name: "bag-type",
        created(){
            this.$store.dispatch("BagType/setBagType");
            this.$store.dispatch("BagType/clearData");
            this.$store.dispatch("BagType/clearSearch");
        },
        data(){
          return{
              delete_id : "",
              event_submit : false,
          }
        },
        computed:{
            ...mapState({
                bagType_List:state=>{
                    return state.BagType.bagTypeList
                },
                form:state=>{
                    return state.BagType.form
                },
                dataPaginate:state=>{
                    return state.BagType.dataPaginate;
                },
                search:state =>{
                    return state.BagType.search;
                }
            })
        },
        methods:{
            showImportBagTypeModal() {
                this.$refs.import_data.show();
            },
            hideImportBagTypeModal() {
                this.$refs.import_data.hide();
                this.$store.dispatch("BagType/clearData");
            },
            showDeleteModal(id) {
                this.delete_id = id;
                this.$refs.delete_data.show();
            },
            hideDeleteModal() {
                this.$refs.delete_data.hide();
                this.$store.dispatch("BagType/setBagType");
            },
            saveBagType(){
                const id = this.form.id;
                console.log(this.form);
                if(!this.form.name){
                    alert("กรุณาเลือกประเภทถุง");
                }else{
                    this.$store.dispatch("BagType/saveBagType",id).then(()=>{
                        this.$store.dispatch("BagType/setBagType");
                        this.hideImportBagTypeModal();
                    })
                }
            },
            editBagType(id){
                this.$store.dispatch("BagType/showBagType",id).then(()=>{
                    this.showImportBagTypeModal()
                });
            },
            deleteBagType(){
                this.$store.dispatch("BagType/deleteBagType",this.delete_id).then(()=>{
                    this.hideDeleteModal();
                })
            },
            searchBagType(){
                this.event_submit = true;
                console.log(this.search);
                this.$store.dispatch("BagType/search",this.search)
            },
            getBagTypePage(){
                const page = this.dataPaginate.current_page;
                //paginate search
                if(this.event_submit){
                    this.$store.dispatch('BagType/search',{
                        page : page,
                        name:this.search.name,
                    })
                }
                //paginate get data
                else{
                    this.$store.dispatch('BagType/setBagType',page)
                }
            },
        }
    }
</script>

<style lang="scss" scoped>

</style>